module.exports = __webpack_public_path__ + "static/media/join-in-img1-2.6521dfd3.jpg";